const moment = require('moment-jalaali');

export default function convertJalaliToGregorian(persianDate) {
	const gregorianDate = moment(persianDate, 'jYYYY-jMM-jDD').format(
		'YYYY-MM-DD'
	);
	return gregorianDate;
}
